export default __webpack_public_path__ + "static/media/roulette1.27c97ad6.png";